import styled from '@emotion/styled';

const StyledWidgetItem = styled.div`
  background-color: ${(props) => props.theme.colors.primary};
  padding: ${(props) => props.theme.padding} 32px;
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 16px;
    @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
      margin-bottom: 0;
    }
  }
  @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
    padding: 32px;

    &:first-of-type {
      margin-right: 12px;
    }
    &:last-of-type {
      margin-left: 12px;
    }
  }

  .count-of-properties {
    color: white;
    font-family: Inter;
    font-size: 22px;
    font-weight: bold;
    line-height: 32px;

    @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
      font-size: 24px;
    }
  }

  .label {
    color: white;
    font-family: Inter;
    font-size: 14px;
    line-height: 30px;
  }
`;

export { StyledWidgetItem };
